import styled from "styled-components";
import { Button, Card, Link, Text } from "../../../../components";
import { media } from "../../../../utils";

const RESIDENCIAL = "residencial";

export const BodyLabelLink = styled(Text)`
  color: ${({ theme }) => theme.color.brandPrimary.light};
  margin-bottom: 4px;
`;

export const NavigationLinkItemStyled = styled(Link)`
  width: 100%;
  height: 100%;
  text-decoration: none !important;
`;

export const NavigationCardItemStyled = styled(Card)`
  & .Card__Body {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  & .Card__Body > div {
    width: 100%;
    max-width: 90%;
  }
`;

export const FormContent = styled.div`
  ${media.md()} {
    width: 30%;
  }
`;

export const DownloadButton = styled(Button)`
  width: 100%;

  ${media.md()} {
    width: auto;
  }
`;

export const ResidencialSelect = styled.select`
  display: ${({ tipoDeSeguro }) =>
    tipoDeSeguro !== RESIDENCIAL ? "none" : ""};
`;

export const CondicoesGeraisCard = styled.div`
  height: fit-content;
  max-width: 374px;
`;

export const CondicoesGeraisCardContainer = styled.div({
  [media.md()]: {
    justifyContent: "space-between",
  },
});
